import { render, staticRenderFns } from "./banner-loader.vue?vue&type=template&id=200d7a2f&scoped=true"
import script from "./banner-loader.vue?vue&type=script&lang=js"
export * from "./banner-loader.vue?vue&type=script&lang=js"
import style0 from "./banner-loader.vue?vue&type=style&index=0&id=200d7a2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200d7a2f",
  null
  
)

export default component.exports